<template>
  <div class="adduserlist">
    <div class="title">
      用户管理 <span>{{titlename}}用户</span>
    </div>
    <div class="main">
      <div class="addUserlistInfo">{{titlename}}用户</div>
      <div class="userlistContent">
        <div class="userlistlist">
          <label for="type"><span>*</span>角色类型</label>
          <el-select v-model="type"
                     size="small"
                     placeholder="请选择用户类型"
                     @change='handleTypeChange'
                     :disabled="typeSelect">
            <el-option v-for="item in typeOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="userlistlist">
          <label for="company"><span>*</span>公司名称</label>
          <el-select v-model="company"
                     size="small"
                     :disabled="companySelect"
                     placeholder="请选择公司名称">
            <el-option v-for="item in companyOptions"
                       :key="item.companyId"
                       :label="item.companyName"
                       :value="item.companyId"></el-option>
          </el-select>
        </div>
        <div class="userlistlist">
          <label for="name">
            <span>*</span>联系人姓名
          </label>
          <el-input size="small"
                    placeholder=""
                    v-model="userlistInfo.name"></el-input>
        </div>
        <div class="userlistlist">
          <label for="phone">
            <span>*</span>注册手机号
          </label>
          <el-input size="small"
                    placeholder=""
                    v-model="userlistInfo.phone"></el-input>
        </div>
        <div class="userlistlist">
          <label for="Status">
            <span>*</span>用户状态
          </label>
          <div class='userlistRadio'>
            <el-radio v-model="radio"
                      label="0">正常</el-radio>
            <el-radio v-model="radio"
                      label="1">禁用</el-radio>
          </div>
        </div>
        <div class="userlistlist">
          <label for="remark">备注</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="userlistInfo.remarks"></el-input>
        </div>
        <div class="userlistBtn">
          <button class="save"
                  @click="handleAddUserlistClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { allCompanyList, userListChange, userListDetail } from 'apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'adduserlist',
  data () {
    return {
      userlistInfo: {
        userId: ''
      },
      typeSelect: false,
      companySelect: true,
      radio: '0',
      type: '',
      typeOptions: [{
        value: '0',
        label: '货主公司'
      }, {
        value: '1',
        label: '物流公司'
      }],
      company: '',
      companyOptions: [],
      titlename: '添加'
    }
  },
  // computed: mapState({
  //   userlistInfo: state => state.userlist.userlistInfo
  // }),
  methods: {
    getData () {
      userListDetail({
        userId: this.userlistInfo.userId
      }).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          this.userlistInfo = res.data.data.result
          this.typeSelect = true
          this.type = this.userlistInfo.userType
          this.userlistInfo.name = this.userlistInfo.petname
          this.userlistInfo.phone = this.userlistInfo.username
          this.radio = this.userlistInfo.state
          this.remarks = this.userlistInfo.remarks
          if (this.userlistInfo.companyId !== '') {
            allCompanyList({
              type: this.userlistInfo.userType
            }).then(res => {
              if (res.data.code === 0) {
                this.company = this.userlistInfo.companyId
                this.companyOptions = res.data.data.result
              }
            })
          }
        }
      })
    },
    handleTypeChange () { // 选择角色类型
      //   console.log(this.type)
      this.companySelect = this.type === ''
      let companyType = this.type === '0' ? '0' : '3'
      //   console.log(companyType)
      allCompanyList({
        type: companyType
      }).then(res => {
        if (res.data.code === 0) {
          this.company = ''
          this.companyOptions = res.data.data.result
        }
      })
    },
    handleAddUserlistClick () { // 添加、修改保存
      // console.log('idididid', this.userlistInfo.userId)
      // console.log('aaadsss', this.userlistInfo.companyId)
      let remarks = !this.userlistInfo.remarks ? '' : this.userlistInfo.remarks
      if (!(/^1[34578]\d{9}$/.test(this.userlistInfo.phone))) {
        this.$message({
          message: '手机号码格式错误',
          type: 'warning'
        })
      } else {
        if (this.userlistInfo.companyId) {
          // console.log('有 ')
          if (!this.type | !this.company | !this.userlistInfo.name | !this.userlistInfo.phone) {
            this.$message({
              message: '*为必选内容',
              type: 'warning'
            })
          } else {
            let addOrSave = 1
            userListChange({
              type: addOrSave,
              userId: this.userlistInfo.userId,
              userType: this.type,
              companyId: this.company,
              petname: this.userlistInfo.name,
              username: this.userlistInfo.phone,
              state: this.radio,
              remarks: remarks
            }).then(res => {
              if (res.data.code === 0) {
                // console.log('xiugaichenggong')
                this.$router.push({ path: '/manage/userlist' })
              }
            })
          }
        } else {
          // console.log('meiyou')
          if (!this.type | !this.userlistInfo.name | !this.userlistInfo.phone) {
            this.$message({
              message: '*为必选内容',
              type: 'warning'
            })
          } else {
            let addOrSave = 0
            userListChange({
              type: addOrSave,
              userType: this.type,
              companyId: this.company,
              petname: this.userlistInfo.name,
              username: this.userlistInfo.phone,
              state: this.radio,
              remarks: remarks
            }).then(res => {
              if (res.data.code === 0) {
                // console.log(res)
                this.$router.push({ path: '/manage/userlist' })
              }
            })
          }
        }
      }
    },
    handleCancelClick () { // 取消添加/修改
      this.$router.push({ path: '/manage/userlist' })
    }
  },
  mounted () {
    // console.log(this.$route.query.item)
    this.userlistInfo.userId = this.$route.query.item
    // console.log(this.userlistInfo.userId)

    if (this.userlistInfo.userId) {
      this.getData()
      this.titlename = '修改'
    }
  }

}
</script>
<style lang="stylus">
.adduserlist
  overflow-y auto
  height calc(100% - 20px)
  width calc(100% - 40px)
  margin 0 20px
  background #fff
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    // height calc(100% - 50px)
    .addUserlistInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../assets/images/03/add_icon.png') no-repeat center left 15px
    .userlistContent
      width 100%
      // height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      // border-bottom 1px solid #CFD5DC
      .userlistlist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
          .tar
            width 50px
            height 30px
            float right
            text-align left
            line-height 15px
          .tarIcon
            width 5px
            height 30px
            float right
            line-height 15px
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
        .userlistRadio
          height 30px
          .el-radio
            width 80px
            .el-radio__label
              color #212832
      .updateTar
        position relative
        .updateFileBtn
          position absolute
          width 112px
          height 30px
          cursor pointer
          background #00D5B9
          text-align center
          text-indent 2em
          line-height 32px
          left 443px
          top 0px
          border-radius 3px
          background url('../../assets/images/07/wenjian_icon.png') no-repeat center left 20px #00D5B9
          size12()
          color #FFFFFF
          .updateBtn
            position absolute
            top 0px
            left 0px
            cursor pointer
            opacity 0
            right 0px
            bottom 0px
            overflow hidden
      .userlistBtn
        margin-left 153px
        margin-top 74px
        margin-bottom 20px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
